import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useUpdateClasse() {
  return useMutation(URL.CLASSES_OPERACAO.ATUALIZAR("id"), async (body: any) => {
    const response = await http.put(URL.CLASSES_OPERACAO.ATUALIZAR(body.id), {
      descricao: body.descricao,
      cor: body.cor,
      ativo: body.ativo,
      operacoesIds: body.operacoesIds,
      operacoesRemovidasIds: body.operacoesRemovidasIds,
    });
    return response;
  });
}

export default useUpdateClasse;
